// extracted by mini-css-extract-plugin
export default {"newAppCalc":"J3OKyVU0","calcBox":"TMVewJZQ"};